import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, Modal, NoContentBox, BigModal } from 'components/basic'
import FlowView from 'components/core/FlowView'
import http from 'API/http'
import { Installation } from 'config'

class Dashboard extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      accesses: [],
      periods: [],
      search: null,
      searchQuery: '',
      searching: false,
      modalState: false,
      billingModal: false
    }
  }
  async componentDidMount () {
    var [err, res] = await http.get('2.4/invoicespecification')
    if (err) return
    this.setState({periods: res.data})
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Dashboard' subtitle='Access' icon='fa-dashboard' />
        <hr />
        <div className='event-configration'>
          <div className='namespace col-lg-3 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Available Accesses</h3>
                <i className='fa fa-fw fa-home' />
              </div>
              <a href='/#/export/access' className='btn full-width btn-primary'><span> <i className='fa fa-cloud-download' /> EXPORT.CSV</span></a>
            </div>
          </div>
          <div className='namespace col-lg-3 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Active Subscriptions</h3>
                <i className='fa fa-fw fa-cog' />
              </div>
              <a href='/#/export/subscriptions' className='btn full-width btn-primary'><span> <i className='fa fa-cloud-download' /> EXPORT.CSV</span></a>
            </div>
          </div>
          {Installation.enable.billingExport &&
          <div className='namespace col-lg-3 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Billing</h3>
                <i className='fa fa-fw fa-balance-scale' />
              </div>
              <a onClick={e => this.setState({billingModal: true})} className='btn full-width btn-primary'><span> <i className='fa fa-cloud-download' /> EXPORT.CSV</span></a>
            </div>
          </div>}
          <div className='namespace col-lg-3 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Help</h3>
                <i className='fa fa-fw fa-question-circle' />
              </div>
              <a onClick={e => this.setState({modalState: true})} className='btn full-width btn-primary'>Open Help</a>
            </div>
          </div>
          <div className='namespace col-lg-3 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Licences</h3>
                <i className='fa fa-fw fa-globe' />
              </div>
              <a onClick={e => (window.location.hash = '/about')} className='btn full-width btn-primary'>View</a>
            </div>
          </div>
        </div>
        <BigModal title='Help' isOpen={this.state.modalState} close={e => this.setState({modalState: false})}>
          <ul>
            <li>To manage services and subscriptions, search for an access in the top right or click Accesses in the left menu.</li>
            <li>To create a new Ticket, search for an access in the top right or click Accesses in the left menu.</li>
            <li>To list and search for open tickets click on Tickets in the left menu.</li>
            <li>To list order history click on Order Events in the left menu</li>
            <li>To list subscription orders click on Orders in the left menu</li>
            <li>To manage your account, click on your name in the upper right corner and select Account.</li>
          </ul>
          <h4>Support</h4>
          <p>If an error occurs in Access please contact the ISP</p>
        </BigModal>
        <Modal title='Billing Export' isOpen={this.state.billingModal} close={e => this.setState({billingModal: false})}>
          {!this.state.periods.length && <NoContentBox icon='folder-o' text='No periods available for exporting.' />}
          <ul className='list-group'>
            {this.state.periods.map(period => {
              return <li key={period.period} className='list-group-item'>
                <a className='badge badge-primary' href={'/#/export/billing/' + period.period}>Download</a>
                {period.period}
              </li>
            })}
          </ul>
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
Dashboard = connect(state => state.siteReducer)(Dashboard)
export default Dashboard



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/core/dashboard.js